import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FormlyFieldConfig } from "@ngx-formly/core";

export function bankFallbackFields(): FormlyFieldConfig[] {
    return [
        {
            fieldGroupClassName: 'flex flex-wrap',
            props: {
                label: _("bank.settings"),
                translate: true
            },
            fieldGroup: [
                {
                    className: "w-full",
                    fieldGroupClassName: "column",
                    fieldGroup: [
                        {
                            className: "w-full",
                            fieldGroupClassName: "flex flex-wrap",
                            fieldGroup: [
                                {
                                    key: 'identifier',
                                    className: "w-full md:w-1/2",
                                    wrappers: ["simple-title"],
                                    type: 'input',
                                    props: {
                                        label: _('bank.identifier'),
                                        translate: true,
                                    },
                                },
                                {
                                    key: 'description',
                                    className: "w-full md:w-1/2",
                                    wrappers: ["simple-title"],
                                    type: 'input',
                                    props: {
                                        label: _('bank.description'),
                                        translate: true,
                                    },
                                },
                                {
                                    key: 'bic',
                                    className: "w-full md:w-1/2",
                                    wrappers: ["simple-title"],
                                    type: 'input',
                                    props: {
                                        label: _('bank.bic'),
                                        translate: true
                                    },
                                },
                                {
                                    key: 'addition',
                                    className: "w-full md:w-1/2",
                                    wrappers: ["simple-title"],
                                    type: 'input',
                                    props: {
                                        label: _('bank.addition'),
                                        translate: true,
                                    },
                                },],
                        },
                        {
                            className: "w-full",
                            fieldGroupClassName: "flex flex-wrap",
                            fieldGroup: [
                                {
                                    key: 'sepaBasicDirectDebit',
                                    type: 'checkbox',
                                    className: "w-1/2 md:w-1/4",
                                    props: {
                                        label: _('bank.sepaBasicDirectDebit'),
                                        translate: true,
                                        required: false,
                                        indeterminate: false,
                                        attributes: {
                                            'data-testid': "formly-bank-sepaBasicDirectDebit"
                                        }
                                    },
                                },
                                {
                                    key: 'sepaB2BDirectDebit',
                                    type: 'checkbox',
                                    className: "w-1/2 md:w-1/4",
                                    props: {
                                        label: _('bank.sepaB2BDirectDebit'),
                                        translate: true,
                                        required: false,
                                        indeterminate: false,
                                        attributes: {
                                            'data-testid': "formly-bank-sepaB2BDirectDebit"
                                        }
                                    },
                                },
                                {
                                    key: 'sepaTransfer',
                                    type: 'checkbox',
                                    className: "w-1/2 md:w-1/4",
                                    props: {
                                        label: _('bank.sepaTransfer'),
                                        translate: true,
                                        required: false,
                                        indeterminate: false,
                                        attributes: {
                                            'data-testid': "formly-bank-sepaTransfer"
                                        }
                                    },
                                }
                            ]
                        },
                        {
                            className: "w-full",
                            fieldGroupClassName: "flex flex-wrap",
                            fieldGroup: [
                                {
                                    key: 'countryIso',
                                    className: "w-1/2 md:w-1/4",
                                    wrappers: ["simple-title"],
                                    type: 'formly-country-input',
                                    props: {
                                        label: _('bank.country'),
                                        translate: true,
                                        autoLoad: false,
                                        isoMode: true,
                                        attributes: {
                                            'data-testid': "formly-bank-country"
                                        }
                                    },
                                },
                                {
                                    key: 'postalCode',
                                    className: "w-1/2 md:w-1/4",
                                    wrappers: ["simple-title"],
                                    type: 'formly-zipcode-auto-complete',
                                    props: {
                                        label: _('bank.postalCode'),
                                        translate: true,
                                        attributes: {
                                            'data-testid': "formly-bank-postalCode"
                                        }
                                    },
                                },
                                {
                                    key: 'city',
                                    className: "w-full md:w-1/2",
                                    wrappers: ["simple-title"],
                                    type: 'input',
                                    props: {
                                        label: _('bank.city'),
                                        translate: true
                                    },
                                },
                            ]
                        },
                    ]
                },
            ]
        },
    ]
}




